import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { findQrRedirect } from '../data/qrRedirects';
import { NotFoundPage } from './NotFoundPage';
/**
 * Vangt de oude QR-URL's op (/blog/qr/...) die eerder door een WordPress-plugin
 * werden afgehandeld. De gedrukte QR-codes wijzen nog steeds naar deze paden,
 * dus die moeten blijven werken.
 *
 * Onbekende slug? Dan tonen we gewoon de 404-pagina, zodat er geen lege of
 * kapotte pagina in beeld komt.
 */
export function QrRedirectPage() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const redirect = findQrRedirect(slug);
  useEffect(() => {
    if (!redirect) return;
    // Zorg dat deze tussenpagina niet in de geschiedenis blijft hangen:
    // de terugknop brengt de bezoeker dan netjes terug naar waar hij vandaan kwam.
    window.location.replace(redirect.target);
  }, [redirect]);
  useEffect(() => {
    // Deze doorstuurpagina hoort niet in Google.
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
  if (!redirect) {
    return <NotFoundPage data-id="element-2025" data-mp="3s19z79f4sumg" />;
  }
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans flex items-center justify-center px-6" data-id="element-2026" data-mp="3rzyp6rv3eqmw">
      <div className="text-center max-w-md" data-id="element-2027" data-mp="t5nzo0aurid">
        <div className="w-12 h-12 mx-auto mb-6 rounded-full border-4 border-gray-200 border-t-[#0B4A6F] animate-spin" aria-hidden="true" data-id="element-2028" data-mp="5v4qyws4nmes" />
        <h1 className="text-xl font-semibold mb-2" data-id="element-2029" data-mp="9u3t69mh552j">Je wordt doorgestuurd…</h1>
        <p className="text-gray-600 mb-6" data-id="element-2030" data-mp="eny9d32vf1wv">
          Een moment geduld, we brengen je naar {redirect.label}.
        </p>
        <a href={redirect.target} className="inline-block text-[#0B4A6F] underline underline-offset-4 font-medium" data-id="element-2031" data-mp="jkyf1cvt62ng">
          Gebeurt er niets? Klik hier om verder te gaan
        </a>
      </div>
    </div>;
}